// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__36MOS","col":"styles_col__2MDq6","fulfillmentStatus":"styles_fulfillmentStatus__3eD_5","emailCol":"styles_emailCol__wGqoE"};